import { useTranslation } from 'react-i18next';
import * as Styled from './FrequencyPreHeader.styled';
import { capitalize } from '../../../utils/capitalize';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A preheader that displays the selected frequency. Only displays under certain
 * configurations, like if there is a single available frequency and that frequency is recurring.
 */
export const FrequencyPreHeader = ({
  frequency,
  cssTextAlign
}) => {
  const {
    t
  } = useTranslation('blocks.impact');
  return /*#__PURE__*/_jsx(Styled.FrequencyPreHeader, {
    cssTextAlign: cssTextAlign,
    children: capitalize(t('FrequencyPreHeader.donationLabel', {
      frequency,
      defaultValue: '{{frequency}} donation'
    }))
  });
};